/* Login form shown inside the Salesforce Voice login frame (InitResult showLogin). */
export function showLoginForm(onSubmit) {
    const root = document.getElementById('login');
    root.hidden = false;
    const form = root.querySelector('form');
    const error = root.querySelector('.error');
    form.onsubmit = async (e) => {
        e.preventDefault();
        error.textContent = '';
        form.querySelector('button').disabled = true;
        try {
            await onSubmit(form.userId.value.trim(), form.password.value);
        } catch (err) {
            error.textContent = err.message;
        } finally {
            form.querySelector('button').disabled = false;
            form.password.value = '';
        }
    };
}

export function hideLoginForm() {
    document.getElementById('login').hidden = true;
}

/** A problem the agent can't fix by signing in (e.g. the org isn't set up): shown instead of the form. */
export function showNotice(message) {
    const root = document.getElementById('login');
    root.hidden = false;
    const form = root.querySelector('form');
    form.querySelectorAll('input, button').forEach((el) => { el.disabled = true; });
    form.querySelector('.error').textContent = message;
}
